export default __webpack_public_path__ + "static/media/Helm of Clawing Might.0bc8dc21.jpg";